import React from 'react';
import { GiftIcon } from 'lucide-react';
const bonuses = [{
  number: '01',
  title: 'The 10-Minute Session Prep System',
  price: '$15',
  body: 'Prep any session in 10 minutes flat: identify the client’s phase, choose the right tome, pick the right tool, and walk in with total clarity — without over-preparing.',
  image: 'https://cdn.magicpatterns.com/uploads/6Y65yTFvb1U3wsXAnbVVRU/bono-1-DPS01-EN.webp'
}, {
  number: '02',
  title: 'The Client Progress Proof Vault',
  price: '$18',
  body: 'Document every insight, breakthrough, and identity shift across the engagement, so the client sees their transformation — and your perceived value goes up.',
  image: 'https://cdn.magicpatterns.com/uploads/iWHn2azGKhdGPp7unaLSCe/bono-2-DPS01-EN.webp'
}, {
  number: '03',
  title: 'The Coach’s Tool Finder Matrix',
  price: '$15',
  body: 'A quick-navigation matrix that tells you exactly which worksheet, script, or framework to use for the situation in front of you. Turns 300 pages into a system you can reference mid-session.',
  image: 'https://cdn.magicpatterns.com/uploads/8CSiSjdLetQtcxzgoWPj22/bono-3-DPS01-EN.webp'
}, {
  number: '04',
  title: 'The Premium Delivery Makeover Kit',
  price: '$18',
  body: 'Delivery scripts, emails, folder structure, and a naming system so every worksheet lands as a premium, high-value tool — not a random PDF.',
  image: 'https://cdn.magicpatterns.com/uploads/uEeEymmpxFhtTVMrSbgPaT/bono-4-DPS01-EN.webp'
}, {
  number: '05',
  title: 'The Stuck Client Emergency Playbook',
  price: '$18',
  body: 'Quick scripts for the hard moments: when the client says “I don’t know,” goes silent, resists, freezes, or spirals. Stay calm and keep direction when the session gets unpredictable.',
  image: 'https://cdn.magicpatterns.com/uploads/m5FReW4ytVSvJcAy3rJWqP/bono-5-DPS01-EN.webp'
}];
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="w-full bg-white" data-id="element-19" data-mp="3ciwsct0r3pkq">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-20" data-mp="3cl0t523cs8gs">
        <div className="text-center" data-id="element-21" data-mp="3hgohjfa0gxl8">
          <span className="inline-flex items-center gap-2 rounded-full bg-terracotta-soft text-terracotta px-4 py-2 text-xs font-bold uppercase tracking-[0.12em]" data-id="element-22" data-mp="3hju7ewqgs3i0">
            <GiftIcon className="w-4 h-4" aria-hidden="true" data-id="element-23" data-mp="3qhe7w3gi5vrk" />
            Included at no extra cost
          </span>
          <h2 id="bonuses-heading" className="mt-5 font-serif font-bold text-ink text-2xl sm:text-4xl" data-id="element-24" data-mp="2tu9naaikr075">
            Total value: <span className="line-through text-ink-muted" data-id="element-25" data-mp="32sv2pwsr1z3p">$84</span>{' '}
            <span className="text-vital" data-id="element-26" data-mp="37jtmj6cy5fbp">→ FREE</span> with your System
          </h2>
        </div>

        <ul className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-27" data-mp="2a4fo3bdj5isw">
          {bonuses.map(bonus => <li key={bonus.number} className="flex flex-col rounded-2xl bg-cream border border-cream-dark shadow-card overflow-hidden" data-id="element-28" data-mp="2f30u5rfgqwp9">
              <div className="bg-white border-b border-cream-dark" data-id="element-29" data-mp="22kwyundp0tbv">
                <img src={bonus.image} alt={`${bonus.title} — bonus ebook cover`} className="w-full h-52 sm:h-56 object-cover" loading="lazy" data-id="element-30" data-mp="22lpw8xqri6hc" />
              </div>
              <div className="flex items-center justify-between gap-3 p-6 pb-0" data-id="element-31" data-mp="1olnh3j9u9r5s">
                <span className="font-serif font-bold text-sm text-terracotta tracking-[0.14em] uppercase" data-id="element-32" data-mp="1jup34qcbp55p">
                  Bonus {bonus.number}
                </span>
                <span className="flex items-center gap-2" data-id="element-33" data-mp="1et9gwuyesslq">
                  <span className="text-sm text-ink-muted line-through" data-id="element-34" data-mp="19xakck2xg4a8">
                    {bonus.price}
                  </span>
                  <span className="rounded-full bg-vital text-white text-[10px] font-bold uppercase tracking-wider px-2.5 py-1" data-id="element-35" data-mp="15tup9s6iabzn">
                    Free
                  </span>
                </span>
              </div>
              <h3 className="mt-3 px-6 font-serif font-bold text-lg sm:text-xl text-ink leading-snug" data-id="element-36" data-mp="3106odp0y60d7">
                {bonus.title}
              </h3>
              <p className="mt-3 px-6 pb-6 text-[15px] leading-relaxed text-ink-soft" data-id="element-37" data-mp="2r77w9x68rrou">
                {bonus.body}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}